<template>
  <v-layout>
    <v-icon
      v-if="!menu"
      small
      :color="selected.length > 0 ? 'primary' : ''"
      @click="menu = true"
    >
      arrow_drop_down
    </v-icon>
    <v-menu
      v-else
      v-model="menu"
      offset-y
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-icon
          small
          :color="selected.length > 0 ? 'primary' : ''"
          v-on="on"
        >
          arrow_drop_down
        </v-icon>
      </template>
      <v-card>
        <v-card-text class="pa-2">
          <v-select
            v-model="selected"
            :items="filteredItems"
            :label="label"
            multiple
            outline
            chips
            small-chips
            :height="selected.length > 1 ? 'auto' : '44'"
            hide-details
            no-data-text="Данных нет"
            return-object
            item-text="title"
            item-value="id"
          >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                small
              >
                {{
                  typeof data.item === "object"
                    ? $options.filters.cropText(data.item.title, 30)
                    : $options.filters.cropText(data.item, 30)
                }}
              </v-chip>
            </template>
            <template
              v-slot:prepend-item
              class="pt-5"
            >
              <v-list-tile
                class="list-fixed-header"
                ripple
              >
                <v-list-tile-action>
                  <v-icon
                    size="19"
                    :color="selected.length > 0 ? 'blue darken-2' : ''"
                    @click="toggle"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <v-layout>
                      <span>Выбрать все</span>
                      <v-spacer />
                      <v-text-field
                        v-model="search"
                        class="mt-0 mb-1 ml-5 pa-0"
                        placeholder="Поиск по элементу"
                        hide-details
                        prepend-inner-icon="search"
                        height="30"
                      />
                    </v-layout>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-layout align-center>
                    <v-btn
                      small
                      color="primary"
                      class="mr-2"
                      flat
                      @click="changeFilter"
                    >
                      Применить
                    </v-btn>
                    <v-btn
                      small
                      flat
                      @click="menu = !menu"
                    >
                      Отменить
                    </v-btn>
                  </v-layout>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-card-text>
      </v-card>
    </v-menu>
  </v-layout>
</template>
<script>
export default {
  props: ["value", "label", "column", "items"],
  data() {
    return {
      menu: false,
      selected: [],
      templateFilter: [],
      search: "",
      filteredItems: [],
    };
  },
  computed: {
    isAllSelected() {
      if (!this.filteredItems) {
        return;
      }
      return this.selected.length === this.filteredItems.length;
    },
    isAnySelected() {
      return this.selected.length > 0 && !this.isAllSelected;
    },
    icon() {
      if (this.isAllSelected) {
        return "disabled_by_default";
      }
      if (this.isAnySelected) {
        return "indeterminate_check_box";
      }
      return "check_box_outline_blank";
    },
  },
  watch: {
    menu() {
      this.selected = this.value;
    },
    value: {
      handler() {
        this.selected = this.value;
      },
      immediate: true,
    },
    items: {
      handler(value) {
        this.filteredItems = value;
      },
      immediate: true,
    },
    search(val) {
      if (!this.items.length) {
        return;
      }
      const searchedItems = [];
      this.items.forEach(i => {
        if (i instanceof Object && i.title.toLowerCase().includes(val)) {
          searchedItems.push(i);
        }
        if (typeof i === "string" && i.toLowerCase().includes(val)) {
          searchedItems.push(i);
        }
      });
      this.filteredItems = searchedItems;
    },
  },
  methods: {
    changeFilter() {
      this.templateFilter = this.selected;
      this.$emit("change", { filter: this.selected, column: this.column });
      this.menu = false;
      this.search = "";
    },
    toggle() {
      this.$nextTick(() => {
        if (this.isAllSelected) {
          this.selected = [];
        } else {
          this.selected = this.filteredItems.slice();
        }
      });
    },
  },
};
</script>
<style>
.v-list > div[role="listitem"]:first-child.list-fixed-header {
  position: sticky;
  top: 0;
  z-index: 9999;
  background: #fff;
  padding: 10px 0;
}
</style>
